import NavigationDesktop from 'ui/snippets/navigation/vertical/NavigationDesktop';

export default NavigationDesktop;
